import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import RulesetAudit from './RulesetAudit';
import JsonataMapping from './JsonataMapping';
import WorkspaceHeuristicsAudit from './WorkspaceHeuristicsAudit';
import { TokenService } from '../services/tokenService';

const AppMain: React.FC = () => {
  const [currentPage, setCurrentPage] = useState('ruleset-audit');
  const [tokenCleared, setTokenCleared] = useState(0);
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false);
  const navigate = useNavigate();

  // Check if user is authenticated
  useEffect(() => {
    const savedToken = TokenService.getToken();
    if (!savedToken || !TokenService.hasValidToken()) {
      console.log('🔒 No valid token found, redirecting to login');
      navigate('/');
      return;
    }
  }, [navigate]);

  const handleNavigate = (page: string) => {
    setCurrentPage(page);
  };

  const handleTokenCleared = () => {
    console.log('🔒 Token cleared, redirecting to login');
    setTokenCleared(prev => prev + 1);
    navigate('/');
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'ruleset-audit':
        return <RulesetAudit key={tokenCleared} />;
      case 'jsonata-mapping':
        return <JsonataMapping key={tokenCleared} />;
      case 'workspace-heuristics-audit':
        return <WorkspaceHeuristicsAudit key={tokenCleared} />;
      default:
        return <RulesetAudit key={tokenCleared} />;
    }
  };

  return (
    <div className="app-main">
      {/* Fleefer Meme GIF */}
      <div className="fleefer-meme">
        <img 
          src="https://c.tenor.com/-pdcCsiB7BEAAAAd/tenor.gif" 
          alt="Fleefer getting juiced" 
          className="fleefer-gif"
        />
        <div className="meme-text-top">OH NO FLEEFER</div>
        <div className="meme-text-bottom">don't get juiced</div>
      </div>

      {/* Navbar */}
      <Navbar 
        activeItem={currentPage}
        onNavigate={handleNavigate}
        onTokenCleared={handleTokenCleared}
        isCollapsed={isNavbarCollapsed}
        onToggleCollapse={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
      />

      {/* Main Content */}
      <div className={`main-content ${isNavbarCollapsed ? 'navbar-collapsed' : ''}`}>
        {renderCurrentPage()}
      </div>
    </div>
  );
};

export default AppMain; 